var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationPin = function SvgLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 72 100"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\n    location_icon\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "none",
    d: "M42.9.771C41.542.5 40.159.333 38.787.122h-5.65c-1.837.327-3.703.561-5.517.999C13.947 4.418 3.387 15.935 1.163 29.761c-1.184 7.355.05 14.387 2.45 21.292 3.361 9.681 8.427 18.471 14.28 26.843 3.611 5.172 7.701 9.938 11.891 14.645 2.109 2.372 4.062 4.888 6.084 7.337h.194c4.219-4.713 8.542-9.344 12.641-14.157 8.732-10.257 15.756-21.528 19.94-34.43 1.76-5.429 2.787-10.987 2.636-16.716C70.848 18.129 59.009 4.037 42.9.771zm-6.899 46.933c-8.515 0-15.423-6.904-15.423-15.419s6.908-15.418 15.423-15.418S51.42 23.77 51.42 32.285s-6.904 15.419-15.419 15.419z",
    fillRule: "nonzero",
    strokeWidth: 1
  }))));
};
export default SvgLocationPin;